import DataVisualization from './DataVisualization';
import Heading from './Heading';
import Figure from './Figure';
import Image from './Image';
import Caption from './Caption';
import Description from './Description';
import Divider from './Divider';
DataVisualization.displayName = "DataVisualizationBase";
Heading.displayName = "DataVisualization.Heading";
Figure.displayName = "DataVisualization.Figure";
Description.displayName = "DataVisualization.Description";
Image.displayName = "DataVisualization.Image";
Caption.displayName = "DataVisualization.Caption";
Divider.displayName = "DataVisualization.Divider";
export { DataVisualization as default, Heading, Figure, Description, Caption, Divider, Image };